import Debug from 'debug';
import { QuizPlayerStateMachineAbstractState, ChildStateMachine,
         QuizMode, QuizPlayerStateMachineCommonEvents } from './quiz-player-state-machine-state'
import { QuizPlayerStateMachineData } from '../data';
import { ExamStateMachine, ExamStateMachinePhase } from '@/app/exam-player/domain';
import { ExamSessionState } from '@/app/exam-session/service';
import { ChildStateMachineHandler } from './child-state-machine-handler';

const debug = Debug('quiz-player-exam-state')

export type QuizExamStartOptions = {
  type: 'new'
  sessionId: string
} | {
  type: 'continue'
  sessionId: string
  state: ExamSessionState
}

interface Events extends QuizPlayerStateMachineCommonEvents {
  onTryAgain: (mode: QuizMode) => void
  onContinueError: () => void
}

export class QuizPlayerExamState extends QuizPlayerStateMachineAbstractState<Events> {

  public readonly name = 'exam'

  private handler: ChildStateMachineHandler

  constructor(
    private data: QuizPlayerStateMachineData,
    private startOptions: QuizExamStartOptions,
    private examStateMachine: ExamStateMachine) {

    super()

    this.handler = new ChildStateMachineHandler('exam', examStateMachine, this)
  }

  enter() {
    debug('enter')
    this.data.goToExam()

    const inputOptions = this.startOptions
    const basic = {
      examId: this.data.quizId,
      aspect: this.data.aspect
    }
    const options = {
      ...inputOptions,
      ...basic
    }

    this.examStateMachine.start(options)
    this.handler.enter()
  }

  exit() {
    debug('exit')
    this.handler.exit()
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.examStateMachine.cancel()
  }

  tryAgain(mode: QuizMode) {
    debug('tryAgain', mode)
    this.handler.tryAgain(mode)
  }
  
  executeChildAction(action: (sm: ChildStateMachine) => void) {
    action(this.examStateMachine)
  }

  executeExamAction(action: (sm: ExamStateMachine) => void) {
    action(this.examStateMachine)
  }
}
